export default "<p>\n  categoria works!\n</p>\n"